import Swiper from 'swiper';
import {A11y, Navigation, Pagination, FreeMode, Thumbs} from 'swiper/modules';

window.Swiper = Swiper;

export function initSwiper() {
    const commonOptions = {

    };

    const sliders = document.querySelectorAll('.swiper-container');

    sliders.forEach((slider) => {
        if (!(slider instanceof HTMLElement)) return;

        let uniqueOptions = {...commonOptions};

        if (slider.classList.contains('swiper-about')) {
            uniqueOptions = {
                ...uniqueOptions,
                modules: [Navigation, A11y],
                slidesPerView: 1, spaceBetween: 10,
                navigation: { nextEl: '.slider-center-about .arrow-next', prevEl: '.slider-center-about .arrow-prev' },
            };
        }

        if (slider.classList.contains('swiper-diplomas')) {
            uniqueOptions = {
                ...uniqueOptions,
                modules: [Navigation, A11y],
                navigation: { nextEl: '.diplomas .arrow-next', prevEl: '.diplomas .arrow-prev' },
                breakpoints: {
                    320: { slidesPerView: 2.2, spaceBetween: 6 },
                    600: { slidesPerView: 4.4, spaceBetween: 6 },
                    1140: { slidesPerView: 4, spaceBetween: 10 },
                },
            };
        }

        if (slider.classList.contains('swiper-result')) {
            uniqueOptions = {
                ...uniqueOptions,
                modules: [Navigation, A11y],
                a11y: true,
                simulateTouch: window.innerWidth < 1024,
                navigation: {
                    prevEl: slider.closest('.result')?.querySelector('.arrow-prev') as HTMLElement,
                    nextEl: slider.closest('.result')?.querySelector('.arrow-next') as HTMLElement,
                },
                breakpoints: {
                    320: { slidesPerView: 1.2, spaceBetween: 10 },
                    500: { slidesPerView: 1.4, spaceBetween: 20 },
                    600: { slidesPerView: 2.7, spaceBetween: 20 },
                    1140: { slidesPerView: 2, spaceBetween: 20 },
                },
                on: {
                    // когда swiper инициализировался → вешаем before/after
                    init(swiper) {
                        const beforeAfterSliders = document.querySelectorAll<HTMLElement>('.before-after-slider');
                        beforeAfterSliders.forEach((baSlider) => initBeforeAfter(swiper, baSlider));
                    },
                },
            };
        }

        if (slider.classList.contains('swiper-result-page')) {
            uniqueOptions = {
                ...uniqueOptions,
                modules: [Navigation, A11y],
                a11y: true,
                navigation: {
                    prevEl: slider.closest('.section-result')?.querySelector('.arrow-prev') as HTMLElement,
                    nextEl: slider.closest('.section-result')?.querySelector('.arrow-next') as HTMLElement,
                },
                breakpoints: {
                    320: { slidesPerView: 1.2, spaceBetween: 10 },
                    500: { slidesPerView: 1.4, spaceBetween: 20 },
                    600: { slidesPerView: 2.7, spaceBetween: 20 },
                    1140: { slidesPerView: 3, spaceBetween: 20 },
                },
                on: {
                    // когда swiper инициализировался → вешаем before/after
                    init(swiper) {
                        const beforeAfterSliders = document.querySelectorAll<HTMLElement>('.before-after-slider');
                        beforeAfterSliders.forEach((baSlider) => initBeforeAfter(swiper, baSlider));
                    },
                },
            };
        }

        if (slider.classList.contains('swiper-publication')) {
            uniqueOptions = {
                ...uniqueOptions,
                modules: [Navigation, A11y],
                navigation: { nextEl: '.publication .arrow-next', prevEl: '.publication .arrow-prev' },
                breakpoints: {
                    320: { slidesPerView: 1.2, spaceBetween: 10 },
                    500: { slidesPerView: 1.4, spaceBetween: 20 },
                    600: { slidesPerView: 3.2, spaceBetween: 6 },
                    1140: { slidesPerView: 2, spaceBetween: 20 },
                },
            };
        }

        if (slider.classList.contains('swiper-interesting')) {
            uniqueOptions = {
                ...uniqueOptions,
                modules: [Navigation, A11y],
                navigation: { nextEl: '.interesting .arrow-next', prevEl: '.interesting .arrow-prev' },
                breakpoints: {
                    320: { slidesPerView: 1.2, spaceBetween: 10 },
                    500: { slidesPerView: 1.4, spaceBetween: 20 },
                    600: { slidesPerView: 3.2, spaceBetween: 6 },
                    1140: { slidesPerView: 2, spaceBetween: 20 },
                },
            };
        }

        if (slider.classList.contains('swiper-doctors')) {
            uniqueOptions = {
                ...uniqueOptions,
                modules: [Navigation, A11y],
                navigation: { nextEl: '.specialists .arrow-next', prevEl: '.specialists .arrow-prev' },
                breakpoints: {
                    320: { slidesPerView: 1.2, spaceBetween: 10 },
                    500: { slidesPerView: 1.4, spaceBetween: 20 },
                    600: { slidesPerView: 3.2, spaceBetween: 6 },
                    1140: { slidesPerView: 2.2, spaceBetween: 20 },
                },
            };
        }

        if (slider.classList.contains('swiper-doctors-center')) {
            uniqueOptions = {
                ...uniqueOptions,
                modules: [Navigation, A11y],
                navigation: { nextEl: '.slider-center-doctors .arrow-next', prevEl: '.slider-center-doctors .arrow-prev' },
                breakpoints: {
                    320: { slidesPerView: 1.2, spaceBetween: 10 },
                    500: { slidesPerView: 1.4, spaceBetween: 20 },
                    600: { slidesPerView: 3.2, spaceBetween: 6 },
                    1140: { slidesPerView: 3, spaceBetween: 20 },
                },
            };
        }

        if (slider.classList.contains('swiper-reviews-center')) {
            uniqueOptions = {
                ...uniqueOptions,
                modules: [Navigation, A11y],
                navigation: { nextEl: '.slider-center-reviews .arrow-next', prevEl: '.slider-center-reviews .arrow-prev' },
                breakpoints: {
                    320: { slidesPerView: 1.2, spaceBetween: 10 },
                    500: { slidesPerView: 1.4, spaceBetween: 20 },
                    600: { slidesPerView: 3.2, spaceBetween: 6 },
                    1140: { slidesPerView: 2, spaceBetween: 20 },
                },
            };
        }

        if (slider.classList.contains('swiper-reviews')) {
            uniqueOptions = {
                ...uniqueOptions,
                modules: [Navigation, A11y],
                navigation: { nextEl: '.reviews .arrow-next', prevEl: '.reviews .arrow-prev' },
                breakpoints: {
                    320: { slidesPerView: 1.2, spaceBetween: 10 },
                    500: { slidesPerView: 1.2, spaceBetween: 20 },
                    600: { slidesPerView: 1.2, spaceBetween: 20 },
                    1140: { slidesPerView: 1.2, spaceBetween: 20 },
                },
            };
        }

        if (slider.classList.contains('swiper-programs')) {
            uniqueOptions = {
                ...uniqueOptions,
                modules: [Navigation, A11y],
                navigation: { nextEl: '.programs .arrow-next', prevEl: '.programs .arrow-prev' },
                breakpoints: {
                    320: { slidesPerView: 1.2, spaceBetween: 10 },
                    500: { slidesPerView: 1.4, spaceBetween: 20 },
                    600: { slidesPerView: 3.2, spaceBetween: 6 },
                    1140: { slidesPerView: 2.2, spaceBetween: 20 },
                },
            };
        }

        if (slider.classList.contains('swiper-complex')) {
            uniqueOptions = {
                ...uniqueOptions,
                modules: [Navigation, A11y],
                navigation: { nextEl: '.slider-center-complex .arrow-next', prevEl: '.slider-center-complex .arrow-prev' },
                breakpoints: {
                    320: { slidesPerView: 1.2, spaceBetween: 10 },
                    500: { slidesPerView: 1.4, spaceBetween: 20 },
                    600: { slidesPerView: 3.2, spaceBetween: 6 },
                    1140: { slidesPerView: 3, spaceBetween: 20 },
                },
            };
        }

        if (slider.classList.contains("slider-partner-text")) {
            // 1️⃣ Инициализация логотипов
            const swiperLogos = new Swiper(".slider-partner-logos", {
                modules: [Thumbs],
                slidesPerView: 'auto',
                freeMode: false,          // отключаем freeMode, чтобы не улетали слайды
                watchSlidesProgress: true, // достаточно для thumbs
                spaceBetween: 20,
                breakpoints: {
                    320: { spaceBetween: 20, slidesPerView: 'auto', },
                    1140: { spaceBetween: 40, slidesPerView: 'auto', },
                    1540: { spaceBetween: 60, slidesPerView: 'auto', }
                },
            });

            // 2️⃣ Инициализация текстовых слайдов и привязка к логотипам
            const swiperTextLogos = new Swiper(".slider-partner-text", {
                modules: [Navigation, A11y, Thumbs],
                slidesPerView: 1,
                spaceBetween: 0,
                autoHeight: true,
                loop: false,
                navigation: {
                    prevEl: ".swiper-arrow_prev",
                    nextEl: ".swiper-arrow_next",
                },
                thumbs: { swiper: swiperLogos },
            });
        }

        if(window.innerWidth < 991){
            let swiper = new Swiper('.standard-slider', {
                centeredSlides: true,
                loop: true,
                breakpoints: {
                    320: {
                        spaceBetween: 20,
                        slidesPerView: 1.3,
                    },
                    750: {
                        spaceBetween: 20,
                        slidesPerView: 2.6,
                    },
                }
            })
            let swiper2 = new Swiper('.service-medical', {
                breakpoints: {
                    320: {
                        spaceBetween: 20,
                        slidesPerView: 1.3,
                    },
                    750: {
                        spaceBetween: 20,
                        slidesPerView: 2.6,
                    },
                }
            })
        }

        new Swiper(slider, uniqueOptions);
    });
}

// Вынесем before/after в отдельную функцию
function initBeforeAfter(swiper: Swiper, slider: HTMLElement) {
    const before = slider.querySelector<HTMLElement>('.before-image');
    const beforeImage = before?.querySelector<HTMLImageElement>('img');
    const resizer = slider.querySelector<HTMLElement>('.resizer');

    if (!before || !beforeImage || !resizer) return;

    let active = false;
    let sliderActive = false;

    beforeImage.style.width = `${slider.offsetWidth}px`;
    beforeImage.style.maxWidth = `${slider.offsetWidth}px`;

    const disableSwiper = () => swiper.disable();
    const enableSwiper = () => swiper.enable();

    window.addEventListener('resize', () => {
        const newWidth = slider.offsetWidth;
        beforeImage.style.width = `${newWidth}px`;
        beforeImage.style.maxWidth = `${newWidth}px`;
    });

    resizer.addEventListener('mousedown', () => {
        active = true;
        sliderActive = true;
        resizer.classList.add('resize');
        disableSwiper();
    });

    document.body.addEventListener('mouseup', () => {
        if (!sliderActive) return;
        active = false;
        resizer.classList.remove('resize');
        enableSwiper();
        sliderActive = false;
    });

    document.body.addEventListener('mouseleave', () => {
        if (!sliderActive) return;
        active = false;
        resizer.classList.remove('resize');
        enableSwiper();
        sliderActive = false;
    });

    document.body.addEventListener('mousemove', (e: MouseEvent) => {
        if (!active) return;
        let x = e.pageX - slider.getBoundingClientRect().left;
        slideIt(x, slider, before, resizer);
        pauseEvent(e);
    });

    resizer.addEventListener('touchstart', () => {
        active = true;
        sliderActive = true;
        resizer.classList.add('resize');
        disableSwiper();
    });

    document.body.addEventListener('touchend', () => {
        if (!sliderActive) return;
        active = false;
        resizer.classList.remove('resize');
        enableSwiper();
        sliderActive = false;
    });

    document.body.addEventListener('touchcancel', () => {
        if (!sliderActive) return;
        active = false;
        resizer.classList.remove('resize');
        enableSwiper();
        sliderActive = false;
    });

    document.body.addEventListener('touchmove', (e: TouchEvent) => {
        if (!active) return;
        let x = e.changedTouches[0].pageX - slider.getBoundingClientRect().left;
        slideIt(x, slider, before, resizer);
        pauseEvent(e);
    });

    function slideIt(x: number, slider: HTMLElement, before: HTMLElement, resizer: HTMLElement): void {
        const transform = Math.max(0, Math.min(x, slider.offsetWidth));
        before.style.width = `${transform}px`;
        resizer.style.left = `${transform}px`;
    }

    function pauseEvent(e: Event): boolean {
        e.stopPropagation();
        e.preventDefault();
        return false;
    }
}